import { connect } from 'react-redux'
import { Zoom } from './Zoom.jsx'
import { getScaleStep } from 'redux/appliedFilters/selectors'

const mapStateToProps = (state, ownProps) => ({
    scaleStep: getScaleStep(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (event, value) => {
        if(typeof ownProps.changeAction === "function") dispatch(ownProps.changeAction(value))
    }
})

export const ZoomContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Zoom)
